import { useContext } from 'react';
import { ShipmentsContext } from '@/src/components/AccountProvider/ShipmentsProvider';

export function useShipmentsContext() {
  return useContext(ShipmentsContext);
}

export default useShipmentsContext;
